
import useNetlifyLogin from '#/useNetlifyLogin'

import { defineComponent, ref, onMounted } from 'vue'

import Flex       from '@/components/layout/Flex.vue'
import HermesLogo from '@/components/gui/HermesLogo.vue'
import LoginForm  from '@/components/gui/LoginForm.vue'

export default defineComponent({
	name: 'Hermes',

	components: {
		Flex,
		HermesLogo,
		LoginForm
	},

	setup () {
		const { isAuthorized } = useNetlifyLogin()
		const isLoggedIn = ref<boolean>(false)

		function onLogin () {
			isLoggedIn.value = isAuthorized()
		}

		onMounted(() => onLogin())

		return {
			isLoggedIn,
			onLogin
		}
	}
})
